

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { RouteNames } from './_routes';

@Component({})
export default class StatusComponent extends Vue {
    routerNames = RouteNames;

    status: string = 'Waiting...';
    m2m: string = 'Waiting...';
    svcustomer: string = 'Waiting...';
    svinmate: string = 'Waiting...';

    sessionsQueueLength: string = 'Waiting...';
    appsQueueLength: string = 'Waiting...';
    autoRegisterAndEnrollQueueLength: string = 'Waiting...';
    manualRegisterAndEnrollQueueLength: string = 'Waiting...';

    async created() {
        // TODO: get from package.json @click='$router.push(&apos;/&apos;)'
        this.status = (await this.$lantern.endpoints.Status.status()).status === 200 ? 'Responsive' : 'Not responsive';
        this.m2m = (await this.$lantern.endpoints.Status.m2m()).data.responsive ? 'Responsive' : 'Not responsive';
        this.svcustomer = (await this.$lantern.endpoints.Status.svcustomer()).data.responsive ? 'Responsive' : 'Not responsive';
        this.svinmate = (await this.$lantern.endpoints.Status.svinmate()).data.responsive ? 'Responsive' : 'Not responsive';

        const queues = await this.$lantern.endpoints.Aws.get();
        this.sessionsQueueLength = queues.data['LanternSessionsQueue.fifo'].messages;
        this.appsQueueLength = queues.data['AppsSessionsQueue.fifo'].messages;
        this.autoRegisterAndEnrollQueueLength = queues.data['AutoRegisterAndEnrollQueue.fifo'].messages;
        this.manualRegisterAndEnrollQueueLength = queues.data['ManualRegisterAndEnrollQueue.fifo'].messages;
    }
}
